export default {
  isPaas: true,
  disableSatismetter: true,
  disableUsetiful: true,
  marketingActivated: true,
  doNotDisplayLogoNColorsSettings: true,
};
